import { useState, useEffect, useCallback } from 'react';
import { SERVER_URL } from '../../constants';

export default function useMissingTransfers(selectedYear) {
  const [missingFlights, setMissingFlights] = useState([]);
  const [internalTransfers, setInternalTransfers] = useState([]);
  const [loading, setLoading] = useState(false);

  const startDate = `${selectedYear}-01-01`;
  const endDate = `${selectedYear}-12-31`;

  const fetchMissingFlights = useCallback(() => {
    setLoading(true);
    const token = sessionStorage.getItem('bearer');

    fetch(`${SERVER_URL}api/missingTransfers?start=${startDate}&end=${endDate}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (res.status === 204 || res.headers.get('Content-Length') === '0') return [];
        if (!res.ok) throw new Error('Failed to fetch missing transfers');
        return res.json();
      })
      .then((data) => {
        sessionStorage.setItem('missingFlights', JSON.stringify(data));
        setMissingFlights(data);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [startDate, endDate]);

  const fetchInternalTransfers = useCallback(() => {
    const token = sessionStorage.getItem('bearer');

    fetch(`${SERVER_URL}api/transfers/internal/range?start=${startDate}&end=${endDate}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (res.status === 204 || res.headers.get('Content-Length') === '0') return [];
        if (!res.ok) throw new Error('Failed to fetch internal transfers');
        return res.json();
      })
      .then((data) => setInternalTransfers(data))
      .catch(console.error);
  }, [startDate, endDate]);

  const refetch = useCallback(() => {
  fetchMissingFlights();
  fetchInternalTransfers();
}, [fetchMissingFlights, fetchInternalTransfers]);

useEffect(() => {
  console.log("🔍 useMissingTransfers mounted for year:", selectedYear);
  fetchMissingFlights();
  fetchInternalTransfers();
}, [selectedYear,fetchMissingFlights, fetchInternalTransfers]);


  return {
  missingFlights,
  internalTransfers,
  loading,
  refetch,
};
}
